import type { FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { OlympicWidgets } from "~/components/olympic-widgets";
import type { Props as ContentSchemaRenderProps } from "~/components/schema-render/content";
import type { articleOlympicWidgetsQuery } from "~/queries/__generated__/articleOlympicWidgetsQuery.graphql";

type Props = Pick<ContentSchemaRenderProps, "advertising">;
export const ArticleOlympicWidgets: FunctionComponent<Props> = ({ advertising }) => {
  const reference = useLazyLoadQuery<articleOlympicWidgetsQuery>(
    graphql`
      query articleOlympicWidgetsQuery {
        ...olympicWidgetsQuery
        ...hooksOlympicWidgetsQuery
      }
    `,
    {},
  );

  return (
    <OlympicWidgets
      advertising={advertising}
      isArticle={true}
      pageType="article"
      reference={reference}
      topStoriesReference={reference}
    />
  );
};

ArticleOlympicWidgets.displayName = "ArticleOlympicWidgets";
